import { FC } from 'react';
import { Route, Routes } from 'react-router-dom';
import Template from './template/Template';
import Landing from './pages/landing/Landing';
import ProductDetail from './pages/productDetail/ProductDetail';
import ProductList from './pages/productList/ProductList';

const App: FC = () => {
  return (
    <Template>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/products" element={<ProductList />} />
        <Route path="/products/:productId" element={<ProductDetail />} />
      </Routes>
    </Template>
  );
};

export default App;
